import { PropsWithChildren } from 'react';
import Modal from '@components/molecules/modal/modal';
import styles from './address-modal.module.scss';

const AddressModalWrapper = ({
  title,
  open,
  onClose,
  children,
}: { title?: string; open: boolean; onClose?: () => void } & PropsWithChildren) => {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      className={styles.modalAddress}
    >
      {children}
    </Modal>
  );
};

export default AddressModalWrapper;
